import { mapGetters } from "vuex";
import { eventBus } from "../main";

export const notifyMixin = {
  methods: {
    fetchTasks() {
      if (this.getView == "list") this.$store.dispatch("fetchTasks");
      if (this.getView == "kanban") {
        this.$store.dispatch("fetchKanbanTasks", "pending");
        this.$store.dispatch("fetchKanbanTasks", "active");
        this.$store.dispatch("fetchKanbanTasks", "completed");
      }
    },

    newComment(payload) {
      // notif from current company
      if (this.getSelectedCompany.id == payload.data.company_id) {
        // Check if task is not active task
        if (
          !(this.getActiveTask && payload.task_id == this.getActiveTask.task_id)
        ) {
          // LIST view
          if (this.getView == "list") {
            // Task found in current store
            if (this.getTask(payload.data.task_id)) {
              this.$store.commit("newComment", {
                task: this.getTask(payload.data.task_id),
              });
              // SORT to latest
              let task = {};
              Object.assign(task, this.getTask(payload.data.task_id));
              this.$store.commit("removeTask", payload.data.task_id);
              this.$store.commit("addNewTask", {
                taskArray: this.getTasks,
                newTaskObj: task,
                pagination: this.getTasksPagination,
              });
            }
            // Task not found in store
            else {
              this.$store
                .dispatch("fetchTask", {
                  task_id: payload.data.task_id,
                  company_id: payload.data.company_id,
                })
                .then((task) => {
                  this.$store.commit("addNewTask", {
                    taskArray: this.getTasks,
                    newTaskObj: task,
                    pagination: this.getTasksPagination,
                  });
                });
            }
          }
          // KANBAN view
          else if (this.getView == "kanban") {
            // Task found in current store
            if (this.getKanbanTask(payload.data.task_id)) {
              this.$store.commit("newComment", {
                task: this.getKanbanTask(payload.data.task_id),
              });
              // SORT to latest
              let task = {};
              Object.assign(task, this.getKanbanTask(payload.data.task_id));
              this.$store.commit("removeKanbanTask", {
                status: task.status,
                task_id: payload.data.task_id,
              });
              this.$store.commit("addKanbanTask", {
                status: task.status,
                task,
                activeTask: this.getActiveTask,
              });
            }
            // Task not found in store
            else {
              this.$store
                .dispatch("fetchTask", {
                  task_id: payload.data.task_id,
                  company_id: payload.data.company_id,
                })
                .then((task) => {
                  if (this.getView == "list")
                    this.$store.commit("addNewTask", {
                      taskArray: this.getTasks,
                      newTaskObj: task,
                      pagination: this.getTasksPagination,
                    });
                  if (this.getView == "kanban")
                    this.$store.commit("addKanbanTask", {
                      status: task.status,
                      task,
                      activeTask: this.getActiveTask,
                    });
                });
            }
          }
        } else
          this.$store.commit("newComment", {
            task: this.getActiveTask,
          });
      }
    },

    completedTask(payload) {
      if (this.getSelectedCompany.id == payload.data.company_id) {
        eventBus.$emit("closeComments", payload.data.task_id);
        if (
          this.getActiveTask &&
          this.getActiveTask.task_id == payload.data.task_id
        ) {
          this.$store
            .dispatch("discardTask", {
              company_id: this.getSelectedCompany.id,
              time_entries: [this.getActiveTimeEntry.entry_id],
            })
            .then(() => {
              this.$store.commit("stopActiveTask", this.$store);
              this.fetchTasks();
            });
        } else {
          this.fetchTasks();
        }
      }
    },

    removedTask(payload) {
      if (this.getSelectedCompany.id == payload.data.company_id) {
        if (
          this.getActiveTask &&
          this.getActiveTask.task_id == payload.data.task_id
        ) {
          this.$store
            .dispatch("discardTask", {
              company_id: this.getSelectedCompany.id,
              time_entries: [this.getActiveTimeEntry.entry_id],
            })
            .finally(() => {
              this.$store.commit("setActiveTask", null);
              this.fetchTasks();
            });
        } else {
          console.log("idr");
          this.fetchTasks();
        }
      }
    },

    assignedTask(payload) {
      if (payload.data.company_id == this.getSelectedCompany.id) {
        if (this.getView == "list") {
          if (this.getTask(payload.data.task_id)) this.fetchTasks();
          else
            this.$store
              .dispatch("fetchTask", {
                task_id: payload.data.task_id,
                company_id: payload.data.company_id,
              })
              .then((task) => {
                this.$store.commit("addNewTask", {
                  taskArray: this.getTasks,
                  newTaskObj: task,
                  pagination: this.getTasksPagination,
                });
              });
        } else if (this.getView == "kanban") {
          if (this.getKanbanTask(payload.data.task_id)) this.fetchTasks();
          else
            this.$store
              .dispatch("fetchTask", {
                task_id: payload.data.task_id,
                company_id: payload.data.company_id,
              })
              .then((task) => {
                this.$store.commit("addKanbanTask", {
                  status: "pending",
                  task,
                  activeTask: this.getActiveTask,
                  new: true,
                });
              });
        }
      }
    },

    acceptInvitation(payload) {
      if (this.getSelectedCompany.id == payload.data.company_id) {
        this.$store.dispatch("fetchTeamMembers");
      }
    },
  },
  computed: {
    ...mapGetters([
      "getActiveTask",
      "getActiveTimeEntry",
      "getTask",
      "getTasks",
      "getTasksPagination",
      "getSelectedCompany",
      "getLoggedInUser",
      "getView",
      "getKanbanTask",
    ]),
  },
};
